<span class="screenreader-only" #iconContainer>{{ altText }}</span>
<img class="svg-wrap" [ngClass]="direction" src="{{ 'assets/icon/svg/' + icon + '.svg' }}" alt="{{ altText }}" />